import { ProductKeys } from '../types/ProductEnums';

type Item = {
  capacity: number;
  [ProductKeys.capacityUnit]: string;
};

const convertCapacityUnit = (item: Item): number => {
  if (item[ProductKeys.capacityUnit] === 'kg' || item[ProductKeys.capacityUnit] === 'l') {
    return item.capacity * 1000;
  }
  return item.capacity;
};

const getCapacityString = (capacity: number | string, capacityUnit: string): string => {
  return capacity ? `${capacity} ${capacityUnit || ''}` : '';
};

export { convertCapacityUnit, getCapacityString };
